<template>
  <v-navigation-drawer
    v-model="drawer"
    app
    right
    temporary
    :width="drawerWidth"
    class="context-help"
  >
    <div class="context-help__toolbar">
      <div>
        <strong>Help</strong>
        <span>Guidance for this page</span>
      </div>
      <v-btn icon aria-label="Close help" @click="drawer = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>

    <div class="context-help__content">
      <HelpArticle :topic="topic" @select-topic="selectTopic" />
    </div>

    <div class="context-help__footer">
      <v-btn block color="primary" depressed @click="openHelpCenter">
        <v-icon left>mdi-help-circle-outline</v-icon>
        Open Help Center
      </v-btn>
    </div>
  </v-navigation-drawer>
</template>

<script>
import HelpArticle from "@/modules/Help/components/HelpArticle.vue"
import { getHelpTopic, getHelpTopicForRoute } from "@/modules/Help/helpTopics"

export default {
  name: "context-help",
  components: { HelpArticle },
  data() {
    return {
      drawer: false,
      topic: getHelpTopicForRoute(this.$route.name),
    }
  },
  created() {
    this.$root.$on("open-context-help", this.openForRoute)
  },
  beforeDestroy() {
    this.$root.$off("open-context-help", this.openForRoute)
  },
  computed: {
    drawerWidth() {
      return Math.min(440, this.$vuetify.breakpoint.width)
    },
  },
  methods: {
    openForRoute(context) {
      const routeName = context && typeof context === "object" ? context.routeName : context
      const topicId = context && typeof context === "object" ? context.topicId : null
      this.topic = topicId ? getHelpTopic(topicId) : getHelpTopicForRoute(routeName || this.$route.name)
      this.drawer = true
    },
    selectTopic(topicId) {
      this.topic = getHelpTopic(topicId)
    },
    openHelpCenter() {
      const query = this.topic.id === "overview" ? {} : { topic: this.topic.id }
      this.drawer = false
      this.$router.push({ name: "help-center", query }).catch(error => {
        if (error.name !== "NavigationDuplicated") console.error(error)
      })
    },
  },
}
</script>

<style scoped>
.context-help { background: #fff; }
.context-help__toolbar { display: flex; align-items: center; justify-content: space-between; min-height: 68px; padding: 10px 14px 10px 22px; color: #fff; background: #2e7d32; }
.context-help__toolbar div { display: flex; flex-direction: column; }
.context-help__toolbar strong { font-size: 17px; font-weight: 600; }
.context-help__toolbar span { color: rgba(255, 255, 255, .76); font-size: 11px; }
.context-help__toolbar .v-btn { color: #fff; }
.context-help__content { padding: 24px 22px 88px; }
.context-help__footer { position: sticky; bottom: 0; padding: 14px 22px; border-top: 1px solid #e5ebe6; background: #fff; }
@media (max-width: 599px) {
  .context-help__content { padding: 20px 18px 88px; }
  .context-help__footer { padding: 12px 18px; }
}
</style>
